import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { approveConsultant } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function ApproveNewConsultant({ open, onClose, consultant }) {
  const [saving, setSaving] = useState(false);

  const handleApprove = async () => {
    setSaving(true);
    try {
      const res = await approveConsultant(consultant?.userId);
      const { data, status } = res?.result;
      openNotification({
        type: 'success',
        title: status?.desc,
      });
      onClose();
    } catch (error) {
      const errmsg = error?.data?.result?.desc;
      openNotification({
        type: 'error',
        title: errmsg,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Approve Consultant
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="info" icon={false}>
          You are about to Approve {consultant?.fullName} as a Consultant
        </Alert>
        <br />
        <Typography>{`Ensure that all neccessary checks and reviews have been done before performing this action`}</Typography>
        {/* <Grid2 container spacing={2}>
          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}></Grid2>
          <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Box
              component={'img'}
              src={activeDoc?.documentUrl}
              sx={{ height: '400px', aspectRatio: '1/1', objectFit: 'cover' }}
            ></Box>
          </Grid2>
        </Grid2> */}
      </DialogContent>
      <DialogActions sx={{ px: 3, pt: 2, pb: 3 }}>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleApprove}
        >
          Yes, Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
